export const log = (severity: keyof Pick<typeof console, 'log' | 'warn' | 'error'>, ...optionalParams: unknown[]) =>
  console[severity]('IMAGISE', ...optionalParams);

export class ImagiseError extends Error {
  constructor(message?: string) {
    super(`IMAGISE: ${message}`);
  }
}

export class SignalAbortedError extends ImagiseError {
  constructor(context: string) {
    super(`${context} 'options.signal' is in 'aborted' state`);
  }
}
